import { dark, PancakeTheme } from '@pancakeswap/uikit'

// Applied to page content and dialogs only; the original navigation keeps its theme.
const surface = '#121214'
const field = '#1c1c1f'
const border = '#ffffff14'
const focus = '0 0 0 3px #ff660033'

export const exchangeTheme: PancakeTheme = {
  ...dark,
  colors: {
    ...dark.colors,
    primary: '#ff6600',
    primaryBright: '#ff9a57',
    primaryDark: '#cc5200',
    secondary: '#ff934d',
    background: '#09090b',
    backgroundAlt: surface,
    backgroundAlt2: '#121214ee',
    backgroundDisabled: '#27272a',
    cardBorder: border,
    contrast: '#fafafa',
    invertedContrast: '#09090b',
    dropdown: field,
    dropdownDeep: '#161618',
    input: field,
    inputSecondary: '#303034',
    tertiary: '#27272a',
    text: '#fafafa',
    textSubtle: '#a1a1aa',
    textDisabled: '#71717a',
    disabled: '#303034',
    overlay: '#000000',
    success: '#4ade80',
    failure: '#f87171',
    gradients: { ...dark.colors.gradients, cardHeader: surface, bubblegum: surface },
  },
  card: {
    ...dark.card,
    background: surface,
    boxShadow: '0 20px 60px -30px #00000099',
    cardHeaderBackground: { default: surface, blue: surface, bubblegum: surface, violet: surface },
  },
  modal: { ...dark.modal, background: surface },
  tooltip: { background: '#27272a', text: '#fafafa', boxShadow: '0 12px 32px #00000066' },
  zIndices: { ...dark.zIndices, modal: 10000 },
  radii: { ...dark.radii, default: '18px', card: '28px' },
  shadows: { ...dark.shadows, focus, active: focus, inset: 'none' },
  toggle: { ...dark.toggle, handleBackground: '#fafafa' },
}
